// Nested selector on Dialog root — higher specificity than MUI's own class rules
export const dialog = {
    '& .MuiDialog-paper': {
        background: '#060638',
        border: '1px solid rgba(187, 188, 188, 0.18)',
        borderRadius: '24px',
        boxShadow: '0 48px 80px -32px rgba(0,0,0,0.8), 0 0 0 1px rgba(0,120,255,0.18)',
        padding: '28px',
        width: '100%',
        maxWidth: '448px',
        position: 'relative',
        margin: '16px',
    },
};

export const backdrop = {
    background: 'rgba(1, 1, 52, 0.72)',
    backdropFilter: 'blur(8px)',
};

export const closeButton = {
    position: 'absolute',
    top: 12,
    right: 12,
    p: 1,
    borderRadius: '8px',
    color: 'var(--ecal-lightgrey)',
    minWidth: 0,
    '&:hover': {
        color: 'var(--ecal-white)',
        background: 'rgba(255,255,255,0.05)',
    },
};

export const header = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    mb: 2,
};

export const symbol = {
    height: 32,
    width: 'auto',
};

export const title = {
    fontSize: '20px',         // matches prototype
    lineHeight: '28px',       // matches prototype (1.4)
    fontWeight: 600,
    color: 'var(--ecal-white)',
};

export const subtitle = {
    fontSize: '0.875rem',
    color: 'var(--ecal-lightgrey)',
    mb: 2.5,
    lineHeight: 1.6,
};

export const providerButton = (isOutlook) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 1,
    width: '100%',
    padding: '13.6px 16px',   // matches prototype exactly → ~51px height
    borderRadius: '12px',
    border: 'none',
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '16px',         // matches prototype
    fontFamily: 'inherit',
    mb: 1.25,
    transition: 'transform 0.18s ease, box-shadow 0.25s ease',
    '&:hover': {
        transform: 'translateY(-1px)',
        boxShadow: '0 12px 28px -10px rgba(255,255,255,0.25)',
    },
    ...(isOutlook ? {
        background: '#0078d4',
        color: '#fff',
    } : {
        background: '#ffffff',
        color: '#1a1a1a',
    }),
});

export const dividerRow = {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    my: 2,
};

export const dividerLine = {
    flex: 1,
    height: '1px',
    background: 'rgba(255,255,255,0.10)',
    border: 'none',
};

export const dividerLabel = {
    fontSize: '12px',         // matches prototype
    color: 'var(--ecal-midgrey)',
};

export const emailLabel = {
    display: 'block',
    fontSize: '0.72rem',
    color: 'var(--ecal-lightgrey)',
    mb: 0.75,
};

export const emailInput = {
    width: '100%',
    background: 'rgba(0,0,0,0.30)',
    border: '1px solid rgba(255,255,255,0.10)',
    borderRadius: '12px',
    padding: '10px 12px',     // matches prototype → ~46px height
    color: 'var(--ecal-white)',
    fontSize: '16px',         // matches prototype
    outline: 'none',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
    '&::placeholder': { color: 'var(--ecal-midgrey)' },
    '&:focus': { borderColor: 'var(--ecal-lightblue)' },
    transition: 'border-color 0.18s ease',
};

export const submitButton = {
    width: '100%',
    mt: 1.25,
    fontSize: '16px',         // matches prototype
    borderRadius: '999px',
};

export const legal = {
    fontSize: '11px',         // matches prototype
    color: 'var(--ecal-midgrey)',
    mt: 2.5,
    lineHeight: 1.7,
};

export const legalLink = {
    color: 'var(--ecal-midgrey)',
    textDecoration: 'underline',
    '&:hover': { color: 'var(--ecal-lightgrey)' },
};
